module.exports = __webpack_public_path__ + "pic_bizny_web_05-375@2x.png?47015c7f176baf8165235b9a4a2d531c";